module.exports = __webpack_public_path__ + "static/media/post-img1.b721080b.jpg";